import { OrderCreateEditController } from './orders-create-edit.directive.controller'

import { $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../../services/system'
import { ORDER_SERVICE_NAME, OrderService } from '../../../../services/order'

import './orders-create-edit.scss'
import * as TEMPLATE from './orders-create-edit.tpl.html'


// Setup

export class OrderCreateEditDirective implements ng.IDirective {

    restrict = 'E'

    controller = [
        $SCOPE_SERVICE_NAME,
        $Q_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        ORDER_SERVICE_NAME,
        (
            $scope: any,
            $q: ng.IQService,
            $timeout: ng.ITimeoutService,
            orderService: OrderService
        ) => new OrderCreateEditController(
            $scope,
            $q,
            $timeout,
            orderService,
            OrderService.REFERENCE_TYPE,
            OrderService.SIMAX_MODULE_NAME
        )]

    controllerAs = '$ctrl'

    template = TEMPLATE
}

// Setup End